export default __webpack_public_path__ + "9c63c631b0c07a6c0949fc3ddffcad2e.png";